<ng-container #iframeLoadHandler="iframeLoadHandler" iframeLoadHandler>
  <mat-progress-bar mode="indeterminate" *ngIf="iframeLoadHandler.loading$ | async" class="absolute"></mat-progress-bar>
  <ng-container *ngIf="showForm$ | async">
    <iframe #iframe class="iframe" [src]="iframeUrl" allow="geolocation"></iframe>
  </ng-container>
</ng-container>
